import { useContext, useEffect, useState } from "react";
import { FC, Props } from "./typings";
import usePDF from "hooks/usePDF";
import KeysContext from "contexts/KeysContext";
import ICAL from "ical.js";
import styles from "./styles.module.scss";

import CalendarIcon from "assets/icons/ical/calendar.svg?react";
import PersonIcon from "assets/icons/ical/person_outline_24px.svg?react";
import AccessTime from "assets/icons/ical/access_time_24px.svg?react";
import moment from "moment";
import Button from "components/Button";
import ModalsManagerContext from "contexts/ModalsManager";
import { formatDate } from "utils/formatDate";
import { useTranslation } from "react-i18next";

const ICALHeader: FC<Props> = ({ pack }) => {
  const { t } = useTranslation();
  const { blob, create } = usePDF();
  const { keys } = useContext(KeysContext);
  const { modals, setModals } = useContext(ModalsManagerContext);

  const [info, setInfo] = useState({
    who: "",
    title: "",
    description: "",
    persons: [],
    start: "",
    end: "",
  });

  useEffect(() => {
    if (!keys.length) return;
    const ical = pack?.Attachments?.find(
      (a) => a.FileName.search("ics") !== -1
    );
    if (!ical) return;
    create(pack.Id, ical, pack.Kind);
  }, [keys]);

  useEffect(() => {
    if (!blob) return;
    blob.text().then((text) => {
      const jcalData = ICAL.parse(text);
      const comp = new ICAL.Component(jcalData);
      const vevent = comp.getFirstSubcomponent("vevent");

      if (vevent) {
        const who = vevent.getFirstPropertyValue("organizer"); // Tytuł
        const summary = vevent.getFirstPropertyValue("summary"); // Tytuł
        const description = vevent.getFirstPropertyValue("description"); // desc
        const startDate = vevent.getFirstPropertyValue("dtstart"); // Data rozpoczęcia
        const endDate = vevent.getFirstPropertyValue("dtend"); // Data zakończenia
        const attendees = vevent.getAllProperties("attendee"); // Lista uczestników

        const attendeesList = attendees.map(
          (attendee) => attendee.getFirstValue().toString().split(":")[1]
        );

        setInfo({
          who: who ? who.toString().split(":")[1] : t("packages.messageSender"),
          title: summary.toString().length
            ? summary.toString()
            : t("packages.noSubjectShort"),
          persons: attendeesList,
          description: description.toString().split("-::~:~:")[0],
          start: moment(startDate.toString()),
          end: moment(endDate.toString()),
        });
      }
    });
  }, [blob]);

  const handleAdd = () => {
    setModals({ ...modals, createEvent: true, hide: false });
    localStorage.setItem("add_to_calendar", JSON.stringify(info));
  };

  if (!info.who && !info.title) return <></>;

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div className={styles.who}>
          <div className={styles.icon}>
            <CalendarIcon />
          </div>
          {info.who}
        </div>
        <div className={styles.title}>
          <div className={styles.icon}></div>
          {info.title}
        </div>
        <div className={styles.description}>
          <div className={styles.icon}></div>
          {info.description}
        </div>
        {info?.persons && info.persons.length > 0 && (
          <div className={styles.persons}>
            <div className={styles.icon}>
              <PersonIcon />
            </div>
            {info.persons.map(
              (a, index) => `${a}${index !== info.persons.length ? "," : ""} `
            )}
          </div>
        )}
        <div className={styles.time}>
          <div className={styles.icon}>
            <AccessTime />
          </div>
          {formatDate([moment(info.start), moment(info.end)])}
        </div>
      </div>
      <div className={styles.right}>
        <Button text={t("calendar.addToCalendar")} onClick={handleAdd} />
      </div>
    </div>
  );
};

export default ICALHeader;
